import { createEntityAdapter } from '@reduxjs/toolkit'

export const storeAdapter = createEntityAdapter<Oms.Store>()
